import axios from "axios"
import { showSnackbar } from "./utilities"

const config = {
  // baseURL:'http://localhost:49975/'
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    // console.log('config', config)
    config.headers.Authorization = "Bearer " + localStorage.getItem("token")
    return config
  },
  function (error) {
    // Do something with request error
    // console.log('error', error)
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    // console.log('response', response)
    return response
  },
  function (error) {
    // Do something with response error
    // console.log('response error', error)
    return Promise.reject(error)
  }
)

export default class WebApi {
  constructor (vuex_store) {
    this._showSnackbar = showSnackbar
    this._store = vuex_store
    this._createSuccessMessage = null
    this._createErrorMessage = null
    this._deleteSuccessMessage = null
    this._deleteErrorMessage = null
    this._editSuccessMessage = null
    this._editErrorMessage = null
    this._readSuccessMessage = null
    this._readErrorMessage = null
    this.status_code = 0
  }

  async get (url) {
    const that = this
    const res = await _axios
      .get(url)
      .then(function (response) {
        if (that._readSuccessMessage !== null) {
          that._showSnackbar(that._store, that._readSuccessMessage, "success")
        }
        return response.data
      })
      .catch(function (error) {
        // console.log(`e=${JSON.stringify(error.response.status)}`);
        if (that._readErrorMessage !== null) {
          that._showSnackbar(that._store, that._readErrorMessage, "error")
        }
        // console.log('webApi error=', error.response)
        if (error.response !== undefined) {
          that.status_code = error.response.status
          return { status_code: error.response.status }
        } else {
          return 400
        }
      })
    return res
  }

  async post (url, data, config) {
    const that = this
    const res = await _axios
      .post(url, data, config)
      .then(function (response) {
        if (that._createSuccessMessage !== null) {
          that._showSnackbar(
            that._store,
            that._createSuccessMessage,
            "success"
          )
        }
        return response.data
      })
      .catch(function (error) {
        if (that._createErrorMessage !== null) {
          that._showSnackbar(that._store, that._createErrorMessage, "error")
        }
        console.log('post error ->', error)
        if (error.response) {
          console.log('error.response ->', error.response)
          return { status_code: error.response.status, message: error.response.data ? error.response.data.detail : '' }
        } else {
          console.error(`${error}`)
          return { status_code: 400, message: 'Неизвестная ошибка' }
        }
      })
    return res
  }

  async put (url, data) {
    const that = this
    const res = await _axios
      .put(url, data)
      .then(function (response) {
        if (that._editSuccessMessage !== null) {
          that._showSnackbar(that._store, that._editSuccessMessage, "success")
        }
        return { data: response.data, status_code: response.status }
      })
      .catch(function (error) {
        if (that._editErrorMessage !== null) {
          that._showSnackbar(that._store, that._editErrorMessage, "error")
        }
        return { data: null, status_code: error.response.status, message: error.response.data ? error.response.data.detail : '' }
      })
    return res
  }

  async patch (url, data) {
    const that = this
    const res = await _axios
      .patch(url, data)
      .then(function (response) {
        if (that._editSuccessMessage !== null) {
          that._showSnackbar(that._store, that._editSuccessMessage, "success")
        }
        return response.data
      })
      .catch(function (error) {
        if (that._editErrorMessage !== null) {
          that._showSnackbar(that._store, that._editErrorMessage, "error")
        }
        return { status_code: error.response.status }
      })
    return res
  }

  async delete (url) {
    const that = this
    const res = await _axios
      .delete(url)
      .then(function () {
        if (that._deleteSuccessMessage !== null) {
          that._showSnackbar(
            that._store,
            that._deleteSuccessMessage,
            "success"
          )
        }
        return true
      })
      .catch(function (error) {
        if (that._deleteErrorMessage !== null) {
          that._showSnackbar(that._store, that._deleteErrorMessage, "error")
        }
        return { status_code: error.response.status }
      })
    return res
  }

  createSuccess (message) {
    this._createSuccessMessage = message
    return this
  }

  deleteSuccess (message) {
    this._deleteSuccessMessage = message
    return this
  }

  editSuccess (message) {
    this._editSuccessMessage = message
    return this
  }

  createError (message) {
    this._createErrorMessage = message
    return this
  }

  deleteError (message) {
    this._deleteErrorMessage = message
    return this
  }

  editError (message) {
    this._editErrorMessage = message
    return this
  }

  readSuccess (message) {
    this._readSuccessMessage = message
    return this
  }

  readError (message) {
    this._readErrorMessage = message
    return this
  }
}
